export const memberSelector = (state) => ({
  memberStatus: state.member.status
});
